import { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDate } from "@/lib/checkins";

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayMelbourne = () => new Date().toLocaleDateString("en-CA", { timeZone: "Australia/Melbourne" });

// Due-date picker (YYYY-MM-DD); past dates disabled.
export function DueDatePicker({ value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const min = new Date(`${todayMelbourne()}T00:00:00`);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-start font-mono-num" data-testid={testId}>
          <CalendarIcon className="mr-1.5 h-4 w-4" />{fmtDate(value)}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single" selected={new Date(`${value}T00:00:00`)} defaultMonth={new Date(`${value}T00:00:00`)}
          disabled={{ before: min }}
          onSelect={(d) => { if (d) { onChange(ymd(d)); setOpen(false); } }}
        />
      </PopoverContent>
    </Popover>
  );
}
